import { scan_barcode } from '../../../../../backbone-unorganized/utils/barcodes';
import { WizardStepPage } from '../../WizardStepPage/view';
import { is_valid_dev_eui } from '../../../../../backbone-unorganized/sensors/sensors';
import { DeviceAddedMessageStepView } from '../DeviceAddedMessageStepView/view';
import { MobileDashboard } from '../../../../../backbone-unorganized/dashboard/views';
import { isWeb } from '../../../../../shared/utils/is';
import { ReactPageWrapper } from '../../../../shared/views/ReactPageWrapper';
import { hideLoadingDialog, showLoadingDialog, showErrorMessage } from '../../../../../shared/utils/notifications';
import { BarcodeScanner } from '@zenput/feature-zencam';

export const LorawanDeviceStepView = WizardStepPage.extend({
    template: '#tpl_lorawan_device_step',
    model: null, // Gateway or Sensor
    stepTitleKey: 'mobile_sensors_device_eui_information',
    success_timeout: 3000, // The length of time (ms) the `device added success` view shows for
    selectedManufacturer: null,

    events: {
        'keyup .barcode_value.eui': 'updateDeviceId',
        'click .field_action_btn': 'scanDevEUI',
        'click .next_step': 'assignDevice'
    },

    templateHelpers: function () {
        return {
            ...LorawanDeviceStepView.__super__.templateHelpers.apply(this, arguments),
            dev_eui: this._getDeviceId(),
            dev_eui_title: 'DevEUI'
        };
    },

    onRender: function () {
        this.updateNextButtonState(this._isEnabled());
    },

    updateDeviceId: function (event) {
        var target = $(event.target);
        this.model.set_device_id(target.val());
        this.updateNextButtonState(this._isEnabled());
    },

    scanDevEUI: async function () {
        if (isWeb()) {
            this.openReactBarcodeScanner();
            return false;
        }

        const scanResult = await scan_barcode();
        if (!scanResult) {
            return false;
        }
        this.model.update_barcode_value(scanResult, this.selectedManufacturer);
        this.displayAddDeviceManually();
        return false;
    },

    openReactBarcodeScanner: function () {
        const onScanSuccess = (scanResult) => {
            this.model.update_barcode_value(scanResult, this.selectedManufacturer);
            this.render();
        };

        $f.mobile.nav.show_modal(ReactPageWrapper, {
            renderFunction: function () {
                return (
                    <BarcodeScanner
                        onResultCallback={(result) => {
                            if (result != null) {
                                onScanSuccess(result);
                            }
                            this.close();
                        }}
                    />
                );
            }
        });
        return;
    },

    assignDevice: function () {
        const this_ = this;
        showLoadingDialog();

        this.model.set('manufacturer', this.selectedManufacturer);

        var account = $f.mobile.dashboard.get_active_account_or_group();

        this.model.sanitize_device_id();
        this.model.save(
            {},
            {
                type: 'POST',
                success: () => {
                    hideLoadingDialog();
                    $f.mobile.nav.show(DeviceAddedMessageStepView);

                    setTimeout(() => {
                        account.fetch({
                            error: function () {
                                $f.mobile.logging.log_error('Error refetching account after device eui entry', {
                                    account,
                                    device: this_.model
                                });
                            },
                            complete: function () {
                                $f.mobile.nav.go_back_to_view(MobileDashboard, {
                                    active_account_or_group: account,
                                    active_tab_id: 'sensors',
                                    do_not_set_leftnav: true,
                                    reset_active_group_or_account_on_close: false
                                });
                            }
                        });
                    }, this.success_timeout);
                },
                error: (_xhr, res) => {
                    hideLoadingDialog();
                    showErrorMessage($f.mobile.sensors.util.get_error_string_from_response(res, true));
                }
            }
        );
    },

    _isEnabled: function () {
        return is_valid_dev_eui(this.model.get_device_id());
    },

    _getDeviceId: function () {
        return this.model.get_device_id();
    }
});
